import {svgjs} from 'svg.js';
import {
	APP_EVT,
	APP_LEVEL,
	INDOOR_OUTDOOR,
	OPTION_TYPE,
	SERIES_ID,
	USER_INTEREST,
	APP_ROLE,
	APP_LOCATION,
	APP_USE
} from 'core/config/constants';
import {CatalogSets} from 'core/services/CatalogSets';
import {Design} from 'core/main/Design';
import {Manipulate} from 'core/main/Manipulate';
import {Placement} from 'core/main/Placement';
import {ItemMenu} from 'core/menus/ItemMenu';
import {Params} from 'core/services/Params';
import {Emitter} from 'core/util/Emitter';
import {Debug} from 'core/util/Debug';

import {Reporting} from 'core/util/Reporting';
import {Stage} from 'core/main/Stage';
import {DesignNotes} from 'core/main/DesignNotes';
import {DesignCodes} from 'core/main/DesignCodes';
import {Init} from 'core/Init';
import {Elevation} from "core/main/Elevation";
import {ExportSvg} from "core/services/ExportSvg";
import {UserData} from "core/services/UserData";

declare var SVG: svgjs.Library;


class Setup {

	public static font_family: string = 'Muli';
	public static header_height: number = 50;
	private _menuAssetsReady: number = 0;


	constructor() {

		$.ajaxSetup({
			headers: {
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
				'x-series-id': Init.series_id.toString()
			}
		});

		if (Init.app_role != APP_ROLE.THUMB) {
			Init.reporting = new Reporting();
		}
		Init.emitter = new Emitter();

		Init.keysdown = [];


		Init.svg_stage = SVG.get('svg-stage') as svgjs.Parent;

		Init.active_level = APP_LEVEL.DECK;

		Init.debug = new Debug();
		if (Init.env == 'dev') Init.debug.toggleDebugOptions();

		Init.set_design = new Design();
		Init.manipulate = new Manipulate();
		Init.design_notes = new DesignNotes();
		let params: Params = new Params();
		let placement: Placement = new Placement();

		if (Init.app_role != APP_ROLE.THUMB) {
			let stage: Stage = new Stage();
		}

		if (Init.app_use == APP_USE.DESIGN) {

			Init.design_codes = new DesignCodes();
			Init.menu = SVG.get('svg-menu-0') as svgjs.Parent;
			let elevation: Elevation = new Elevation();
			let catalogSets: CatalogSets = new CatalogSets();

		}

		$('#svg-icons').load(Init.base_url + '/images/layout/icons.svg', this.stageCallback);
		$('#svg-items').load(Init.base_url + '/appConfig/getModelSvg/?series_id=' + Init.series_id, this.menuCallback);

		this.loadParams();
		this.setGlobals();

		Init.emitter.on(APP_EVT.FLASH_SUCCESS, this.showSuccess);
		Init.emitter.on(APP_EVT.FLASH_ERROR, this.showError);
		Init.emitter.on(APP_EVT.APP_READY, this.appReady);

		let btns: Array<any> = [];
		btns['.btn-print-toggle'] = [APP_EVT.PRINT_DESIGN];

		if (Init.app_use == APP_USE.DESIGN) {

			//console.log('is design');

			$('#scale-slider').on('input', function (event) {

				let val: number = Number($(event.target).val());
				Init.emitter.emit(APP_EVT.SCALE_DESIGN, val, Init.design_scale);

			});


			btns['.btn-rotate-left'] = [APP_EVT.ROTATE_DESIGN, 'left'];
			btns['.btn-rotate-right'] = [APP_EVT.ROTATE_DESIGN, 'right'];
			btns['.btn-flip-across'] = [APP_EVT.FLIP_DESIGN, 'across'];
			btns['.btn-flip-over'] = [APP_EVT.FLIP_DESIGN, 'over'];
			btns['.btn-move-up'] = [APP_EVT.MOVE_DESIGN, 0, -5];
			btns['.btn-move-down'] = [APP_EVT.MOVE_DESIGN, 0, 5];
			btns['.btn-move-left'] = [APP_EVT.MOVE_DESIGN, -5, 0];
			btns['.btn-move-right'] = [APP_EVT.MOVE_DESIGN, 5, 0];

			btns['#btn-modal-save'] = [APP_EVT.SHOW_SAVE_MODAL];
			btns['#btn-save'] = [APP_EVT.SAVE_CHECK];

			btns['#btn-save-over-yes'] = [APP_EVT.SAVE_DESIGN];

			btns['#btn-modal-retrieve'] = [APP_EVT.SHOW_RETRIEVE_MODAL];
			btns['#btn-retrieve'] = [APP_EVT.RETRIEVE_USER_DESIGN];
			btns['#btn-modal-design-list'] = [APP_EVT.SHOW_DESIGN_LIST_MODAL];

			btns['#btn-modal-request-quote'] = [APP_EVT.SHOW_QUOTE_REQUEST_MODAL];

			btns['#btn-edit-level'] = [APP_EVT.TOGGLE_ACTIVE_LEVEL];
			btns['#btn-modal-catalog-sets'] = [APP_EVT.SHOW_CATALOG_SETS];
			btns['#btn-modal-library-sets'] = [APP_EVT.SHOW_LIBRARY_OPENER];
			btns['#btn-modal-share-3d'] = [APP_EVT.SHOW_SHARE_3D_MODAL];
			btns['#btn-item-options'] = [APP_EVT.TOGGLE_EDIT_OPTIONS];

			btns['#btn-toggle-debug'] = [APP_EVT.TOGGLE_DEBUG_PANEL];
			btns['#btn-toggle-tools'] = [APP_EVT.TOGGLE_TOOL_PANEL];
			btns['#btn-toggle-labels'] = [APP_EVT.TOGGLE_BAY_LABELS];
			btns['#btn-debug-toggle-clickclip'] = [APP_EVT.TOGGLE_DEBUG_CLICKCLIP];
			btns['#btn-debug-toggle-dimensions'] = [APP_EVT.TOGGLE_DEBUG_DIMENSIONS];
			btns['#btn-debug-toggle-sbox'] = [APP_EVT.TOGGLE_DEBUG_SBOX];
			btns['#btn-debug-toggle-ybox'] = [APP_EVT.TOGGLE_DEBUG_YBOX];
			btns['#btn-debug-toggle-xbox'] = [APP_EVT.TOGGLE_DEBUG_XBOX];
			btns['#btn-debug-toggle-tbox'] = [APP_EVT.TOGGLE_DEBUG_TBOX];
			btns['#btn-debug-toggle-posts'] = [APP_EVT.TOGGLE_DEBUG_POSTS];

			btns['#btn-toggle-menu'] = [APP_EVT.TOGGLE_MENU];
			btns['#btn-open-3d'] = [APP_EVT.VIEW_3D];
			btns['.btn-toggle-roofs'] = [APP_EVT.TOGGLE_ROOF_PANEL];
			btns['.btn-toggle-floors'] = [APP_EVT.TOGGLE_FLOOR_PANEL];
			btns['#btn-toggle-show-fences'] = [APP_EVT.TOGGLE_SHOW_FENCES];

			btns['.btn-toggle-fences'] = [APP_EVT.TOGGLE_FENCE_PANEL];
			btns['.btn-toggle-playhouse'] = [APP_EVT.TOGGLE_ELEVATION_PANEL];
			btns['#btn-playhouse-trim-color-1'] = [APP_EVT.SET_PLAYHOUSE_COLOR, 1];
			btns['#btn-playhouse-trim-color-2'] = [APP_EVT.SET_PLAYHOUSE_COLOR, 2];
			btns['#btn-notes-toggle'] = [APP_EVT.TOGGLE_NOTES];
			btns['.btn-codes-toggle'] = [APP_EVT.TOGGLE_CODES];
			btns['#panel-item-codes .btn-close'] = [APP_EVT.TOGGLE_CODES];


			$('#intro-disable').on('change', function () {

				//localStorage.setItem('disable_intro', $(this).prop('checked'));
				Init.setStorage('disable_intro', $(this).prop('checked'));

			});

			$('.btn-roof').on('click', function () {

				Init.emitter.emit(APP_EVT.ROOF_SET_STYLE, OPTION_TYPE.ROOF_STYLE, $(this).val());

			});


			$('#btn-roof-rotate').on('click', function () {

				Init.emitter.emit(APP_EVT.ROOF_ROTATE, OPTION_TYPE.ROOF_ROTATION, 90);

			});


			$('.btn-cupola').on('click', function () {

				Init.emitter.emit(APP_EVT.ROOF_SET_CUPOLA, OPTION_TYPE.CUPOLA_STYLE, $(this).val());

			});

			$('.btn-roof-color').on('click', function () {

				Init.emitter.emit(APP_EVT.ROOF_COLOR_SET, OPTION_TYPE.ROOF_COLOR, $(this).val());

			});

			$('.btn-floor').on('click', function () {

				Init.emitter.emit(APP_EVT.FLOOR_SET_STYLE, $(this).val());

			});


			$('#btn-export-svg').on('click', function () {

				let ex: ExportSvg = new ExportSvg();

				ex.export('svg-stage');

			});


			$('#btn-save-over-no').on('click', function () {

				$('#modal-www-save').modal('hide');
				$('#btn-save').removeClass('btn-active');

			});

			$('#btn-delete-all-yes').on('click', function () {

				Init.emitter.emit(APP_EVT.DELETE_ALL);
				$('#btn-delete-all').removeClass('btn-active');
				$('#modal-delete-all').hide();

			});

			$('#btn-delete-all-no').on('click', function () {

				$('#btn-delete-all').removeClass('btn-active');
				$('#modal-delete-all').hide();

			});

			$('#panel-item-options').on('click', 'ul li', function () {

				let option: any = {
					items: [$(this).attr('data-item')],
					name: $(this).attr('data-option'),
					value: $(this).attr('data-value')
				};
				Init.emitter.emit(APP_EVT.ITEM_OPTION_CHANGE, option);

			});


			// set a modal-active boolean, so we can use it to block keyboard events while modals are open

			$('.modal').on('hide.bs.modal', function (e) {
				Init.modal_active = false;
			});
			$('.modal').on('show.bs.modal', function (e) {
				Init.modal_active = true;
			});
		}

		for (let btn in btns) {

			$(btn).on('click', function (evt) {

				Init.emitter.emit(btns[btn][0], ...btns[btn].slice(1));

			});
		}

		$('.btn-print-print').on('click', function () {

			(<any>window).print();

		});

		if (Init.app_role != APP_ROLE.THUMB) {

			document.addEventListener('keydown', function (event: KeyboardEvent) {

				let key: string = event.key;

				let exists: number = Init.keysdown.indexOf(key);

				if (exists == -1) {
					Init.keysdown.push(key);
				}

				if (Init.modal_active === false) {

					switch (key) {

						case 'Enter':
							Init.emitter.emit(APP_EVT.KEY_DOWN_ENTER);
							break;

						case '+':
							// Plus on numpad and keyboard
							Init.emitter.emit(APP_EVT.SCALE_DESIGN, (Init.design_scale * 10) + 1, Init.design_scale);
							break;

						case '-':
							// Minus and dash
							Init.emitter.emit(APP_EVT.SCALE_DESIGN, (Init.design_scale * 10) - 1, Init.design_scale);
							break;

						case 'ArrowLeft':
						case 'ArrowRight':
						case 'ArrowUp':
						case 'ArrowDown':

							let x: number = 0;
							let y: number = 0;

							if (Init.keysdown.indexOf('ArrowLeft') != -1) {
								x = -5;
							}
							if (Init.keysdown.indexOf('ArrowUp') != -1) {
								y = -5;
							}
							if (Init.keysdown.indexOf('ArrowRight') != -1) {
								x = 5;
							}
							if (Init.keysdown.indexOf('ArrowDown') != -1) {
								y = 5;
							}

							if (x != 0 || y != 0) {
								Init.emitter.emit(APP_EVT.MOVE_DESIGN, x, y);
							}

							break;
					}

				} else {

					// allow the Enter Key event to be sent even when modals are open.
					// this allows us to save designs without having to navigate to the button.
					switch (key) {

						case 'Enter':
							// ENTER key
							Init.emitter.emit(APP_EVT.KEY_DOWN_ENTER);
							break;
					}
				}
			});

			document.addEventListener('keyup', function (event) {

				let exists: number = Init.keysdown.indexOf(event.key);

				if (exists != -1) {
					Init.keysdown.splice(exists, 1);
				}

			});

			document.addEventListener('wheel', Setup.onWheel);

			if (Init.app_location == APP_LOCATION.WWW) UserData.submit();

		}

		$(window).on('resize', function () {

			Setup.onresize();

		});
	}

	static onWheel = (event: WheelEvent): void => {

		// only scale the set if the mouse pointer is directly over the grid, not the sidebar or header.
		if ($("#design-frame:hover").length != 0) {

			//event.preventDefault();

			let dir: number = (event.deltaY > 0) ? 1 : -1;

			Init.emitter.emit(APP_EVT.SCALE_DESIGN, (Init.design_scale * 10) + dir, Init.design_scale);

		}
	};


	static onresize = (): void => {

		if (Init.app_role != APP_ROLE.THUMB && Init.is_touch_device !== true) {

			let window_height: number = $(window).height();

			$('#sidebar').css({'height': window_height - (Setup.header_height + 2), 'top': Setup.header_height});

		} else {

			Init.manipulate.autoCenterDesign();
		}
	};


	loadParams = (): void => {

		let data: any = {};
		data.series_id = Init.series_id;

		let _that = this;

		$.ajax({
			type: 'POST',
			url: Init.base_url + '/appConfig/getParams',
			dataType: 'json',
			data: data
		})
			.done(function (this: any, data) {
				Params.add(data);
				_that.menuCallback(data, 'success');
			})
			.fail(function (data) {

			})
			.always(function (data) {

			});

	};


	showSuccess = (data): void => {

		//console.log(data);

	};


	showError = (data): void => {

		if (Init.app_use == APP_USE.DESIGN) {

			let panel: string = '#modal-blank';

			$(panel).modal('toggle');

			$(panel + ' #msg').html(`${data.name}: ${data.message}`);
		}
	}


	/**
	 * need to make sure that both the menu SVGs and the item data
	 * are fully loaded before we draw the menu, so the ItemMenu class
	 * is not instantiated until the second time this function is called.
	 *
	 * @param data
	 * @param evt
	 */
	menuCallback = (data, evt): void => {

		if (evt == 'success') {
			this._menuAssetsReady += 1;
		}

		if (this._menuAssetsReady == 2) {

			let menu: ItemMenu = new ItemMenu();

		}
	}


	stageCallback = (): void => {

		// don't draw grid until we know we have loaded the SVG.
		// load the grid defs seperately from the models, so we can
		// hide models without hiding the grid.
		$('.svg-grid').html('<rect width="100%" height="100%" fill="url(#' + Init.grid_svg + ')"/>').hide();
		//console.log('stageCallback', Init.design_scale);
	}


	/**
	 * called when the menu has fully loaded - which means we have all SVG and item parameters
	 * and so can load a design for the user automatically when the app loads.
	 */
	appReady = (): void => {

		if (Init.app_role == APP_ROLE.LIBRARY) {
			$('#modal-warning').modal('show');
		}
		//console.log('x',  Init.design_name != '', Init.design_name);
		if (Init.design_name != '') {

			if (Init.design_source == 'library') {

				Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_BY_ID, Init.design_id, 'library');
				//Init.emitter.emit(APP_EVT.RETRIEVE_LIBRARY_SET, Init.design_id);

			} else if (Init.design_source == 'catalog') {

				Init.emitter.emit(APP_EVT.RETRIEVE_CATALOG_SET, Init.design_id);

			} else {

				let data: any = {};
				data.design_name = Init.design_name;
				data.design_id = Init.design_id;
				data.series_id = Init.series_id;

				let url: string = (Init.app_location == APP_LOCATION.WWW) ? '/data/retrieveDesignPartnerDesign' : '/data/retrieveByName';

				$.ajax({
					type: 'POST',
					url: url,
					dataType: 'json',
					data: data
				})
					.done(function (data) {
						Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);

						if (Init.app_location == APP_LOCATION.WWW) {
							Init.emitter.emit(APP_EVT.SET_GTAG, 'open_design_partner');
						}
					})
					.fail(function (data) {
						Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
					})
					.always(function (data) {
						Init.emitter.emit(APP_EVT.RETRIEVE_SUCCESS, data);
					});
			}

			$('.svg-grid').fadeIn(200);

		} else {

			//Init.emitter.emit(APP_EVT.SCALE_DESIGN, localStorage.getItem('design_scale'));
			Init.emitter.emit(APP_EVT.SCALE_DESIGN, Init.getStorage('design_scale'));

			//console.log('is design', localStorage.getItem('design_scale'));

			if (Init.design_id != '' && Init.design_source != 'catalog') {

				let data: any = {};
				data.design_name = Init.design_name;
				data.design_id = Init.design_id;
				data.series_id = Init.series_id;
				data.source = Init.design_source;

				let host: string = Init.design_source_host;
				let url: string = host + '/data/retrieveById';

				$.ajax({
					type: 'POST',
					url: url,
					dataType: 'json',
					data: data
				})
					.done(function (data) {
						Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);

						if (Init.app_location == APP_LOCATION.WWW) {
							Init.emitter.emit(APP_EVT.SET_GTAG, 'open_' + Init.design_source + '_design');
						}

					})
					.fail(function (data) {
						Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
					})
					.always(function (data) {
						Init.emitter.emit(APP_EVT.RETRIEVE_SUCCESS, data);
					});

			} else if (Init.app_use == APP_USE.DESIGN) {

				if (Init.app_location == APP_LOCATION.WWW) {

					// logic here to show the intro modal if we are on the website
					//let show: string = localStorage.getItem('disable_intro');
					let show: string = Init.getStorage('disable_intro');

					if (show !== 'true') {
						$('#modal-intro').modal('show');
					}

				} else if (Init.app_location == APP_LOCATION.OFFICE) {

					// logic here to show the intro modal if we are on the website
					//let show: string = localStorage.getItem('disable_intro');
					let show: string = Init.getStorage('disable_intro');

					if (show !== 'true') {
						$('#modal-intro').modal('show');
					}
				}
			}
			if (Init.app_role != APP_ROLE.THUMB) {
				$('.svg-grid').fadeIn(200);
			}
		}

		Init.emitter.emit(APP_EVT.TOGGLE_TOOL_PANEL);

		Setup.onresize();

		if (Init.app_role != APP_ROLE.THUMB) {

			$('#svg-logo-box .line-name').text(Init.line_name).css('color', Init.line_color);
			$('#svg-logo-box .app-version').text(`v${Init.app_version}`).css('color', Init.line_color);
			$('#tools #btns-right #btn-switch-tool').css('backgroundColor', Init.line_color);
			$('#scale-slider').tooltip();

			$('#svg-stage').on('mouseup', function (this: void) {

				Init.emitter.emit(APP_EVT.STAGE_MOUSE_UP);

			});
		}
	}


	setGlobals(): void {

		switch (Init.series_id) {
			case SERIES_ID.COMMERCIAL_2ANDOVER:
			case SERIES_ID.COMMERCIAL_OUTDOOR:
			case  SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
			case  SERIES_ID.COMMERCIAL_OUTDOOR_UNDER2:
				Init.user_interest = USER_INTEREST.COMMERCIAL;
				break;

			default:
				Init.user_interest = USER_INTEREST.RESIDENTIAL;
				break;

		}

		switch (Init.series_id) {
			case SERIES_ID.COMMERCIAL_2ANDOVER:
			case SERIES_ID.RESIDENTIAL_INDOOR:
			case  SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
				Init.indoor_outdoor = INDOOR_OUTDOOR.INDOOR;
				break;

			default:
				Init.indoor_outdoor = INDOOR_OUTDOOR.OUTDOOR;
				break;

		}

	}


}

export {Setup};
